import { render } from "./EnrolmentList.vue?vue&type=template&id=216c2704"
import script from "./EnrolmentList.vue?vue&type=script&lang=ts"
export * from "./EnrolmentList.vue?vue&type=script&lang=ts"
script.render = render

export default script